import template from "./hb-b.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import { QrCode } from "../../../models/QrCode";
//import { HeartBank } from "../../../managers/HeartBank";
import { HbAvatar } from "../../hb-avatar/hb-avatar";

export class HbB extends HTMLElement {
    //private heartbank = new HeartBank();
    private qrCode = new QrCode();

    private chest: HTMLPictureElement;
    private heart: SVGElement;
    private qr: HTMLElement;
    private code: HTMLImageElement;
    private sm: HTMLSpanElement;
    private avatar: HTMLElement;

    private animationFrameId: number | null = null;
    private isAnimating = false;
    private lastTime = 0;
    private readonly interval = 1500; // 1.5 seconds

    constructor() {
        super();
        render(template, this);

        this.chest = this.querySelector("picture")!;
        this.heart = this.chest.firstElementChild as SVGElement;
        this.qr = this.querySelector("#hb-b-qr")!;
        this.code = this.qr.firstElementChild as HTMLImageElement;
        this.sm = this.qr.lastElementChild as HTMLSpanElement;
        this.avatar = this.querySelector("#hb-b-avatar")!;
    }

    connectedCallback() {
        //this.heartbank.addAuthStateListener((user) => {});
    }

    // attribute names are case-insensitive in HTML
    static get observedAttributes() {
        return [
            "karat", // weight
            "render", // "none", "code", "avatar"
            "heartbeat", // boolean
            "rainbow" // boolean
        ];
    }

    get karat(): string {
        return this.getAttribute("karat") ?? "silver"; // default silver
    }

    set karat(value: string) {
        this.setAttribute("karat", value);
    }

    get render(): string {
        return this.getAttribute("render") ?? "none";
    }

    set render(value: "none" | "code" | "avatar") {
        this.setAttribute("render", value);
    }

    get heartbeat(): boolean {
        return this.hasAttribute("heartbeat");
    }

    set heartbeat(value: boolean) {
        if (value) this.setAttribute("heartbeat", "");
        else this.removeAttribute("heartbeat");
    }

    get rainbow(): boolean {
        return this.hasAttribute("rainbow");
    }

    set rainbow(value: boolean) {
        if (value) this.setAttribute("rainbow", "");
        else this.removeAttribute("rainbow");
    }

    attributeChangedCallback(
        name: string,
        oldValue: string | null,
        newValue: string | null
    ) {
        switch (name) {
            case "karat":
                if (newValue)
                    this.heart.style.fill =
                        newValue === "random"
                            ? this.getRandomHexColor()
                            : newValue;
                break;
            case "heartbeat":
                this.chest.classList.toggle(
                    "animate-heartbeat",
                    this.heartbeat
                );
                break;
            case "rainbow":
                if (this.rainbow) {
                    if (!this.isAnimating) {
                        this.isAnimating = true;
                        this.lastTime = performance.now(); // reset timer
                        this.animationFrameId = requestAnimationFrame(
                            this.animateColor
                        );
                    }
                } else {
                    if (this.animationFrameId !== null) {
                        cancelAnimationFrame(this.animationFrameId);
                        this.animationFrameId = null;
                        this.isAnimating = false;
                    }
                }
                // window.setInterval(
                //     () => (this.heart.style.fill = this.getRandomColor()),
                //     1500
                // );
                break;
            case "render":
                switch (newValue) {
                    case "none":
                        this.qr.classList.add("hidden");
                        this.avatar.classList.add("hidden");
                        this.chest.addEventListener(
                            "click",
                            this.changeColor.bind(this)
                        );
                        break;
                    case "code":
                        this.qr.classList.remove("hidden");
                        this.avatar.classList.add("hidden");
                        this.chest.removeEventListener(
                            "click",
                            this.changeColor.bind(this)
                        );
                        break;
                    case "avatar":
                        this.qr.classList.add("hidden");
                        this.avatar.classList.remove("hidden");
                        this.chest.removeEventListener(
                            "click",
                            this.changeColor.bind(this)
                        );
                        break;
                }
                break;
        }
    }

    renderAvatar(user: User | string) {
        const avatar = this.avatar.firstElementChild as HbAvatar;
        avatar.render(user);
    }

    updatePhoto(url: string) {
        const avatar = this.avatar.firstElementChild as HbAvatar;
        avatar.updatePhoto(url);
    }

    // not used
    async renderCode(
        data: string,
        isBlack: boolean = true,
        rotation: 0 | 90 | 180 | 270 = 180
    ) {
        //this.showSpinner();
        const url = await this.qrCode.mint(isBlack, data);
        this.code.src = url;

        if (isBlack) {
            this.sm.classList.add("text-black");
            this.sm.classList.remove("text-white");
        } else {
            this.sm.classList.remove("text-black");
            this.sm.classList.add("text-white");
        }

        this.code.classList.remove("-rotate-0");
        this.code.classList.remove("-rotate-90");
        this.code.classList.remove("-rotate-180");
        this.code.classList.remove("-rotate-270");

        switch (rotation) {
            case 0:
                this.code.classList.add("-rotate-0");
                break;
            case 90:
                this.code.classList.add("-rotate-90");
                break;
            case 180:
                this.code.classList.add("-rotate-180");
                break;
            case 270:
                this.code.classList.add("-rotate-270");
                break;
        }

        //this.hideSpinner();
    }

    // not used ?
    show(user: User | null = null) {
        if (user) this.renderAvatar(user);
        this.classList.remove("hidden");
        // this.chest.classList.remove("hidden");
        // if (heart && code) {
        //     this.heart.classList.remove("hidden");
        //     this.code.classList.remove("hidden");
        // } else if (heart) {
        //     this.heart.classList.remove("hidden");
        //     this.code.classList.add("hidden");
        // } else {
        //     this.heart.classList.add("hidden");
        //     this.code.classList.remove("hidden");
        // }
    }

    // not used ?
    hide() {
        this.classList.add("hidden");
        // this.chest.classList.add("hidden");
        // this.heart.classList.add("hidden");
        // this.code.classList.add("hidden");
    }

    private animateColor = (time: number): void => {
        if (time - this.lastTime >= this.interval) {
            this.heart.style.fill = this.getRandomColor();
            this.lastTime = time;
        }
        this.animationFrameId = requestAnimationFrame(this.animateColor);
    };

    private changeColor() {
        this.heart.style.fill = this.getRandomColor();
    }

    private getRandomColor(): string {
        const hex = Math.floor(Math.random() * 16777215).toString(16);
        return `#${hex.padStart(6, "0")}`;
    }

    private getRandomHexColor(): string {
        return (
            "#" +
            Math.floor(Math.random() * 0xffffff)
                .toString(16)
                .padStart(6, "0")
        );
    }
}
